import * as React from "react"
import { Box, Typography, Skeleton } from "@mui/material"
import { TableSeeker, IconSeeker } from "@ui-seeker/core"

import { tableData, totalCount, isLoadingTable, selectedBrand } from "../@signals"
import { 
    idSkuColumn, 
    referenceColumn, 
    nameColumn, 
    eanColumn, 
    companyColumn, 
    brandColumn, 
    lineColumn, 
    imageColumn,
    customersColumn,
    mappingsCountColumn,
    actionsColumn
} from "./columns"
import MappingsModal from "../MappingsModal"
import EditMappingDrawer from "../MappingsDrawer"
import { mappingsModal } from "../@signals"


export default function SkuManagementTable() {
    const data = tableData.value
    const total = totalCount.value
    const isLoading = isLoadingTable.value
    const brand = selectedBrand.value

    if (!brand) {
        return (
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                py: 8,
                color: '#9ca3af',
                backgroundColor: '#fff',
                borderRadius: 1,
                border: '1px solid #e5e7eb'
            }}>
                <IconSeeker icon="tag" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="body1">
                    Select a brand to view its SKUs
                </Typography>
            </Box>
        )
    }

    if (isLoading) {
        return <Skeleton variant="rectangular" height={500} sx={{ mt: 2 }} />
    }

    return (
        <>
            <TableSeeker
                data={data}
                title={`SKUs (${total})`}
                columns={[
                    idSkuColumn(),
                    eanColumn(),
                    lineColumn(),
                    imageColumn(),
                    nameColumn(),
                    customersColumn(),
                    mappingsCountColumn(),
                    actionsColumn(),
                    referenceColumn(),
                    companyColumn(),
                    brandColumn()
                ]}
                options={{
                    selectableRows: 'none',
                    sortOrder: {
                        name: 'id_sku',
                        direction: 'asc'
                    },
                    rowsPerPage: 100,
                    rowsPerPageOptions: [10, 20, 50, 100, 200]
                }}
                textLabels={{
                    body: {
                        noMatch: 'No SKUs found for this brand.'
                    }
                }}
            />
            <MappingsModal />
            <EditMappingDrawer onMappingUpdated={() => {
                // Reload mappings when a mapping is updated
                const modalData = mappingsModal.value
                if (modalData?.id_sku) {
                    // Trigger reload by clearing and resetting modal
                    const currentModal = { ...modalData }
                    mappingsModal.value = null
                    setTimeout(() => {
                        mappingsModal.value = currentModal
                    }, 0)
                }
            }} />
        </>
    )
}
